import styled from 'styled-components';
import { Absolute, Box, Text } from '@rsos/components/capstone/base';
import { fadeIn, fadeOut } from '../fadeAnimations.styles';

export const MenusContainer = styled(Box).attrs({
  horizontal: true,
  inline: true,
})``;

export const MenuContainer = styled(Box).attrs({
  minWidth: '48px',
  align: 'center',
  marginX: '8px',
})`
  opacity: ${({ isAddonDisabledForGoogle }) =>
    isAddonDisabledForGoogle ? '30%' : '100%'};

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const MenuIcon = styled(Box).attrs({
  width: '40px',
  height: '40px',
  borderRadius: '5px',
  overflow: 'hidden',
})`
  background-image: ${({ backgroundImage }) => `url(${backgroundImage})`};
  background-position: center center;
  background-size: contain;
  box-shadow: inset 0 0 0 1.5px
    ${({ isAddonDisabledForGoogle, isAddonLockedForEsri, isSelected, theme }) =>
      !isAddonDisabledForGoogle && (isAddonLockedForEsri || isSelected)
        ? `${theme.colors.primaryBase}`
        : 'transparent'};
  transition: box-shadow 250ms ease-in-out;
  cursor: pointer;

  &:hover {
    box-shadow: inset 0 0 0 1.5px
      ${({ isAddonDisabledForGoogle, isAddonLockedForEsri, theme }) =>
        isAddonDisabledForGoogle
          ? 'transparent'
          : isAddonLockedForEsri
          ? `${theme.colors.primaryBase}`
          : `${theme.colors.secondaryText}`};
  }
`;

export const MenuTitle = styled(Text).attrs(
  ({ isAddonDisabledForGoogle, isSelected }) => ({
    marginTop: '2px',
    size: 'small',
    fontWeight: 'regular',
    color:
      !isAddonDisabledForGoogle && isSelected ? 'primaryBase' : 'secondaryText',
    textAlign: 'center',
  }),
)``;

export const TooltipPosition = styled(Absolute).attrs({
  top: '-38px',
  left: '50%',
})`
  transform: Translate(-50%, 0);

  ${fadeOut}
`;

export const BasemapsAddonsBodyContainer = styled(Box).attrs({
  position: 'relative',
})`
  &:hover ${TooltipPosition} {
    ${({ isAddonDisabledForGoogle, isAddonLockedForEsri }) =>
      (isAddonDisabledForGoogle || isAddonLockedForEsri) && `${fadeIn}`}
  }
`;
